import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckSvgComponent } from './check.component';



@NgModule({
  declarations: [
    CheckSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    CheckSvgComponent
  ]
})
export class CheckSvgModule { }
